import $ from 'jquery';
import debug from 'bows';
import breakpoints from '../_breakpoints';

class FeaturedContent {

	constructor( node, options ) {
		this.debug = debug('layout:slider');
		this.node = node;
		this.$node = $(node);
		this.options = options;
		this.items = this.node.getAttribute('data-items');
		this.transitionInterval = parseInt(this.node.getAttribute('data-interval'), 10);

		this.$wrap = this.$node.find('.flex-layout__wrap');
		this.$media = this.$node.find('.flex-layout--featured-content__media');
		this.$medium = this.$node.find('.flex-layout--featured-content__medium');
		this.$figures = this.$media.find('.flex-layout--featured-content__medium__figure');
		this.$figureItems = this.$figures.find('img, iframe');
		this.$iframes = this.$figureItems.filter('iframe');
		this.$contentsWrap = this.$node.find('.flex-layout--featured-content__contents');
		this.$contents = this.$node.find('.flex-layout--featured-content__content');
		this.$content = this.$node.find('.flex-layout--featured-content__item__content');
		this.$nav = this.$node.find('.flex-layout--featured-content__nav');
		this.$navs = this.$nav.find('a');
		this.$prev = this.$node.find('a[href="#prev"]').on('click', (e) => {
			e.preventDefault();
			this.clearInterval();
			this.prev()
		});
		this.$next = this.$node.find('a[href="#next"]').on('click', (e) => {
			e.preventDefault();
			this.clearInterval();
			this.next();
		});
		this.activeClass = 'flex-layout--featured-content--active';

		this.$nav.on('click', 'a', (e) => {
			e.preventDefault();
			this.clearInterval();
			this.goTo(e.currentTarget.hash.substr(1));
		});

		this.$window = $(window);
		this.resize();

		this.$window.on('resize', this.resize.bind(this));
		this.$window.on('load', this.resize.bind(this));
		this.$window.on('focusin', this.resize.bind(this));

		this.goTo(0);

		if (!isNaN(this.transitionInterval) && this.transitionInterval > 0) {
			this.interval = setInterval( this.next.bind(this), this.transitionInterval * 1000 );
		}

		this.$node.addClass(this.activeClass);

		this.$contents.css('transition-property', 'height, top');
	}

	resize() {
		let windowWidth = this.$window.width();
		let wrapWidth   = this.$wrap.width();
		let mediaWidth  = this.$media.width();
		let mediumHeight  = this.$figures.filter(`.${this.activeClass}`).find('img, iframe').first().outerHeight();
		let contentHeight = this.$content.filter(`.${this.activeClass}`).height();
		let contentWrapHeight = contentHeight + (this.$nav.is(':visible') ? this.$nav.outerHeight(true) : 0) + parseInt(this.$contentsWrap.css('padding-top'), 10) + parseInt(this.$contentsWrap.css('padding-bottom'), 10);

		if (windowWidth >= breakpoints.medium) {
			this.$medium.css({
				width: `${Math.ceil(mediaWidth + ((windowWidth - wrapWidth) / 2))}px`,
				height: `${mediumHeight}px`
			});

			// for those awkward stages where the content is taller than the image
			if (contentWrapHeight > mediumHeight) {
				this.$wrap.css({
					height: `${contentWrapHeight}px`,
					paddingTop: `${(contentWrapHeight - mediumHeight) / 2}px`
				});
			} else {
				this.$wrap.css({
					height: ``,
					paddingTop: ''
				});
			}
		} else {
			this.$medium.css({
				width: '',
				height: `${mediumHeight}px`
			});
			this.$contentsWrap.css('top', '');
			this.$wrap.css({
				height: '',
				paddingTop: ''
			});
		}

		this.$contents.css('height', `${contentHeight}px`);
		this.$contentsWrap.css('height', `${contentWrapHeight}px`);

		if ( typeof this.resizeTimeout !== 'number' ) {
			this.resizeTimeout = setTimeout( () => {
				this.resize();
				clearInterval(this.resizeTimeout);
				delete this.resizeTimeout;
			}, 50 );
		}
	}

	goTo(index) {
		this.debug('goTo', index);

		this.$figures.filter(`.${this.activeClass}`).removeClass(this.activeClass);
		this.$content.filter(`.${this.activeClass}`).removeClass(this.activeClass);
		this.$navs.filter(`.${this.activeClass}`).removeClass(this.activeClass);

		this.$figures.eq(index).addClass(this.activeClass);
		this.$content.eq(index).addClass(this.activeClass);
		this.$navs.eq(index).addClass(this.activeClass);

		this.resize();

		this.curIndex = index;
	}

	next() {
		if (this.curIndex >= this.items - 1) {
			this.goTo(0);
			return;
		}

		this.goTo( this.curIndex + 1 );
	}

	prev() {
		if (this.curIndex === 0) {
			this.goTo(this.items - 1);
			return;
		}

		this.goTo( this.curIndex - 1 );
	}

	clearInterval() {
		if ( typeof this.interval === 'number' ) {
			window.clearInterval(this.interval);
			this.interval = null;
		}
	}

}

export default FeaturedContent;
